//#region src/scripts/extenders/footer-details.js
var FooterElement = class extends HTMLElement {
	constructor() {
		super();
		const details = this.querySelectorAll("details");
		if (window.innerWidth >= 1050) details.forEach((detail) => {
			detail.disabled = true;
			detail.open = true;
		});
		else details.forEach((detail) => {
			detail.open = false;
		});
	}
};
if (customElements.get("footer-handler") === void 0) customElements.define("footer-handler", FooterElement);
//#endregion
